import XorgCheck from './org-check.vue';
export default XorgCheck;



// WEBPACK FOOTER //
// ./src/xman/org-check/index.js